module.exports = __webpack_public_path__ + "static/media/8.dc3cf92d.jpg";